<template>
  <v-layout column class="relative pl-2">
    <div
      style="width: 100%;height: 130px;background: rgb(236, 236, 236);position: absolute;top: 19px;"
    >
      <v-icon
        style="font-size: 131px;color: rgb(250, 251, 251);position: absolute;right: 9px;bottom: -27px;"
      >person_outline</v-icon>
    </div>

    <v-tabs slider-color="grey darken-3" style="position:relative;top:100px;">
      <v-tab>Account</v-tab>
      <v-tab>Billing</v-tab>

      <v-tabs-items>
        <v-tab-item>
          <v-card flat>
            <v-card-text class="pt-4 pb-4">Account info goes here if any</v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-title class="headline" primary-title>Your Billing Details</v-card-title>
            <v-card-text>This information will appear on the invoice that you will receive from LingoAV</v-card-text>
            <v-card-text>
              <v-form ref="form" class>
                <v-container grid-list-xl>
                  <v-layout wrap justify-space-between>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="billingCompanyName"
                        :counter="50"
                        maxlength="50"
                        :rules="requiredField"
                        label="Company"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="billingVAT"
                        :counter="30"
                        maxlength="30"
                        :rules="requiredField"
                        label="VAT Number"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="billingAddress"
                        :counter="100"
                        maxlength="100"
                        :rules="requiredField"
                        label="Address"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="billingCity"
                        :counter="30"
                        maxlength="30"
                        :rules="requiredField"
                        label="City"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="billingState"
                        :rules="requiredField"
                        :counter="20"
                        maxlength="20"
                        label="State/Province/Region"
                      ></v-text-field>
                      <v-text-field
                        v-model="billingZip"
                        :rules="requiredField"
                        :counter="10"
                        maxlength="10"
                        label="ZIP Code"
                      ></v-text-field>
                      <v-autocomplete
                        v-model="billingCountry"
                        label="Country"
                        :items="countries"
                        :rules="requiredField"
                        required
                        filled
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-end">
              <v-btn color="primary" flat @click="validateAndSave">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-layout>
</template>


<style>
.v-tabs__bar {
  background: transparent !important;
}

.v-tabs .v-card__text {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>

<script>
import customerBillingInfoService from "../service/customerBillingInfoService";

export default {
  name: "lingo_user_profile",
  data() {
    return {
      billingCompanyName: undefined,
      billingAddress: undefined,
      billingCity: undefined,
      billingState: undefined,
      billingCountry: undefined,
      billingZip: undefined,
      billingVAT: undefined,
      requiredField: [v => !!v || "Field is required"],
      countries: this.$store.getters.countries
    };
  },
  methods: {
    validateAndSave() {
      if (!this.$refs.form.validate()) {
        return;
      }
      var customerBillingInfo = {
        name: this.billingCompanyName,
        billingAddress: this.billingAddress,
        country: this.country,
        taxId: this.billingVAT,
        zipCode: this.billingZip,
        city: this.billingCity,
        state: this.billingState
      };

      customerBillingInfoService
        .createCustomerBillingInfoPromise(customerBillingInfo)
        .then(
          function(response) {
            if (response.status != 200) {
              alert("Handle error for response status different from 200");
            }
          },
          function(err) {
            alert(err);
          }
        );
    }
  },
  mounted() {
    var that = this;
    customerBillingInfoService
      .getCustomerBillingInfoPromise()
      .then(function(response) {
        that.billingCompanyName = response.data.name;
        that.billingAddress = response.data.billingAddress;
        that.billingCity = response.data.city;
        that.billingState = response.data.state;
        that.billingZip = response.data.zipCode;
        that.billingVAT = response.data.taxId;
        that.billingCountry = response.data.country;
      });
  }
};
</script>
